import { GETPOLICIESLIST_SUCCESS, GETPOLICIESLIST_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getPolicyListForRequestTimeOffReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETPOLICIESLIST_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETPOLICIESLIST_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getPolicyListForRequestTimeOffReducer;
